import type { FaqCategory } from '../../@types/Faq';
import type { FaqCategory as Category } from '../../@types/FaqCategory';

export const createArticleUrl = (categories: FaqCategory[], slug: string) =>
  `/${categories[0].slug}/${slug}`;

const base = (search?: string) => {
  const params = new URLSearchParams(search);
  params.append('targetAudience', 'User');
  params.append('hits', '100');
  return params;
};

export const getFaqsURLSearchParams = (currentCategory: Category | undefined, search?: string) => {
  const params = new URLSearchParams(base(search));
  if (currentCategory) {
    const p = encodeURIComponent(currentCategory.slug);
    params.append('category', p);
  }
  if (params.get('q')) {
    params.append('sort', 'relevance');
  }
  params.sort();
  return params;
};

export const getFaqURLSearchParams = (query: string) => {
  const params = new URLSearchParams(base());
  params.append('q', query);
  params.append('sort', 'relevance');
  params.sort();
  return params;
};

export const getCategoriesURLSearchParams = () => {
  const params = new URLSearchParams(base());
  params.append('sort', 'relevance');
  params.sort();
  return params;
};

export const getCategory = (categories: Category[] | undefined, pathname?: string) => {
  if (categories && pathname) {
    const splitted = pathname.split('/');
    if (splitted && splitted.length >= 2) {
      const category = splitted?.[2]?.split('?')?.[0];
      return category ? categories.find((c) => c.slug === category) : undefined;
    }
  }
  return undefined;
};
